import { inject } from 'aurelia-framework';
import { AppRouter } from 'aurelia-router';

@inject(Element, AppRouter)
export class HrefCustomAttribute {

    value: string = '';

    private forceNavigate = (event: MouseEvent) => {
        if (this.value === location.hash) {
            this.router.navigate(this.value, { replace: true });
            event.preventDefault();
        }
    }

    constructor(private readonly element: HTMLAnchorElement, private readonly router: AppRouter) { }

    attached() {
        if (this.element instanceof HTMLAnchorElement) {
            this.element.addEventListener('click', this.forceNavigate);
        }
    }

    detached() {
        this.element.removeEventListener('click', this.forceNavigate);
    }

    valueChanged(href: string) {
        this.element.href = href;
    }
}
